// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "categories-landing-" + (chunkId === 226 ? "webfooter-Footer" : chunkId) + "-st-" + {"13":"062236ed","33":"d3452593","213":"b1e97bbc","226":"fd828acc","393":"25aa6d18","750":"c17529be","846":"d2afbfaf"}[chunkId] + ".js";
};